// Libs
import React from 'react'

// CSS
import './styles.scss'

// Img
import downloadImg from '../../assets/download.svg'
import downloadSuccessImg from '../../assets/download-success.svg'
import downloadErrImg from '../../assets/download-err.svg'

const UpDownIcon = ({ err, type, progress, children }) => {
  const radius = 16
  const strokeWidth = 3
  const margin = 2
  const width = 2 * radius + strokeWidth + margin

  return (
    <div className="up-down-icon-icon">
      <div className="up-down-icon__progress">
        <svg
          width={width}
          height={width}>
          <circle
            cx={width / 2}
            cy={width / 2}
            r={radius}
            fill="none"
            stroke="#B2B2B2"
            strokeWidth={strokeWidth} />
          <circle
            r={radius}
            cx={width / 2}
            cy={width / 2}
            fill="none"
            stroke={err ? '#FF5252' : '#12B7A3'}
            strokeWidth={strokeWidth}
            strokeDasharray={2 * 3.14 * radius}
            strokeDashoffset={2 * 3.14 * radius * (1 - progress)} />
        </svg>
      </div>
      <div className="up-down-icon__center">
        {progress === 0 &&
          <img src={downloadImg} alt="" />
        }
        {progress === 1 &&
          <img src={downloadSuccessImg} alt="" />
        }
        {err &&
          <img src={downloadErrImg} alt="" />
        }
        {progress !== 0 && progress !== 1 &&
          <p>{Math.round(30)}</p>
        }
      </div>
    </div>
  )
}

export default UpDownIcon
